module.exports = __webpack_public_path__ + "static/media/stock_patient_man.9b83d5ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ipd552/stock_patient_man.png
// module id = 185
// module chunks = 0